// extracted by mini-css-extract-plugin
module.exports = {"commentsCard":"comments_commentsCard__2o9AQ","greyLabel":"comments_greyLabel__3BbJB","commentText":"comments_commentText__1G7bY"};